import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=73bc5105&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
import style0 from "./Categories.vue?vue&type=style&index=0&id=73bc5105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc5105",
  null
  
)

export default component.exports